import _ from 'lodash';
import classnames from 'classnames';
import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import ActionMixin from './lib/action_mixin';
import ActiveCallControlsContainer from './phone_controls/active_call_controls_container';
import ActiveCallElapsedTime from './phone_controls/active_call_elapsed_time';
import AgentChannelStatusControls from './page_layout/agent_channel_status_controls';
import AgentInfoBar from './page_layout/agent_info_bar';
import analytics from 'scripts/lib/analytics';
import AppFeaturesMixin from 'components/lib/app_features_mixin';
import BackButtonContainer from 'components/lib/back_button_container';
import { getLocationUrl } from 'scripts/adapters/routes/location_url';
import ErrorBoundary from 'components/common/utilities/error_boundary';
import Link from 'components/common/link';
import MessageNotificationsMenu from 'components/page_layout/message_notifications_menu';
import NavigateHome from 'actions/current_location/navigate_home';
import NavigateTo from 'actions/current_location/navigate_to';
import ProgressBar from 'components/common/progress_bar';
import ProvidersMixin from './lib/providers_mixin';
import Search from 'models/location/search';
import SharedBindings from 'components/lib/shared_bindings_mixin';
import track from 'scripts/presentation/components/lib/track';

const PageLayout = createReactClass({
  mixins: [ActionMixin, AppFeaturesMixin, Morearty.Mixin, ProvidersMixin, SharedBindings],

  statics: {
    TOP_BAR_HEIGHT: 60,
  },

  propTypes: {
    children: PropTypes.node,
    className: PropTypes.string,
    showLoading: PropTypes.bool,
    childrenContainerClassName: PropTypes.string,
  },

  UNSAFE_componentWillMount() {
    this.observeBinding(this.getSharedBinding('activeCall'));
    this.observeBinding(this.getSharedBinding('agentStatus'));
    this.observeBinding(this.getSharedBinding('currentAgent'));
    this.observeBinding(this.getSharedBinding('personalInboxCounts'));
    this.observeBinding(this.getSharedBinding('searchResults'));
  },

  getActiveCall() {
    return this.getProvider('activeCall').get();
  },

  getCurrentAgent() {
    return this.getProvider('currentAgent').get();
  },

  render() {
    const divProps = _.pick(this.props, ['id']);
    return (
      <div {...divProps} className={classnames('page', this.props.className)}>
        {this.renderProgressBar()}
        {this.renderPageTopBar()}
        {this.renderChildren()}
      </div>
    );
  },

  renderChildren() {
    return (
      <div className={classnames('page-childrenContainer', this.props.childrenContainerClassName)}>
        <ErrorBoundary renderError={({ onResolveError }) => <PageLayoutError onClickContinue={onResolveError} />}>
          {this.props.children}
        </ErrorBoundary>
      </div>
    );
  },

  renderPageTopBar() {
    return (
      <div className="page-top-bar">
        <div className="hamburger-spacer" />
        <BackButtonContainer />
        <MessageNotificationsMenu />
        {this.renderTopBarContents()}
      </div>
    );
  },

  renderTopBarContents() {
    const activeCall = this.getActiveCall();
    const currentAgent = this.getCurrentAgent();
    const isAgentCurrentlyOnCall =
      activeCall && activeCall.isAgentOnLiveCall(currentAgent.id) && activeCall.hasLiveConnection();

    if (!this.canPerformAgentActions()) {
      return (
        <ul className="agent-info-bar-container">
          {this.renderLogo()}
          <li className="agentInfoBar-topNavOption">
            <AgentInfoBar />
          </li>
        </ul>
      );
    } else if (isAgentCurrentlyOnCall) {
      return (
        <ul className="agent-info-bar-container agentInfoBarContainer-activeCall">
          <ActiveCallControlsContainer />
          <li className="agentInfoBar-topNavOption topNav-search topNav-search-liveCall">
            {this.renderSearchButton()}
          </li>
          <li className="agentInfoBar-topNavOption">
            <div className="agentInfoBar-divider" />
          </li>
          {this.renderActiveCallElapsedTime()}
        </ul>
      );
    }
    return (
      <ul className="agent-info-bar-container">
        {this.renderLogo()}
        <li className="agentInfoBar-topNavOption agentStatusControls-container">
          <AgentChannelStatusControls />
        </li>
        <li className="agentInfoBar-topNavOption">
          <div className="agentInfoBar-divider" />
        </li>
        <li className="agentInfoBar-topNavOption topNav-search topNav-search-icon">{this.renderSearchButton()}</li>
        <li className="agentInfoBar-topNavOption">
          <AgentInfoBar />
        </li>
      </ul>
    );
  },

  renderLogo() {
    return (
      <div className="top-nav-container">
        <ul className="top-nav">
          <li className="agentInfoBar-topNavOption">
            <Link
              href="/home"
              className="agentInfoBar-homeLogo"
              onClick={track.click('gladlyLogo-myInbox', this.navigateToHome)}
            >
              <div className="page-logo" />
            </Link>
          </li>
        </ul>
      </div>
    );
  },

  navigateToHome() {
    this.executeAction(NavigateHome);
  },

  renderSearchButton() {
    return (
      <Link className="agentInfoBar-search-link" href={this.getSearchUrl()} onClick={this.navigateToSearch}>
        <i className="icon-search ion-ios-search" />
      </Link>
    );
  },

  getSearchUrl() {
    return getLocationUrl(Search.create());
  },

  navigateToSearch(event) {
    event.preventDefault();
    this.executeAction(NavigateTo, Search.create());
  },

  renderActiveCallElapsedTime() {
    return (
      <li className="agentInfoBar-topNavOption agentInfoBar-topNavOption-activeCallTimer">
        <ActiveCallElapsedTime />
      </li>
    );
  },

  renderProgressBar() {
    return <ProgressBar isVisible={this.props.showLoading} />;
  },

  canPerformAgentActions() {
    return this.getProvider('appFeatures')
      .get()
      .isEnabled('internalAgentActions');
  },
});

function PageLayoutError({ onClickContinue }) {
  useEffect(() => {
    analytics.track('Whoops Screen Shown', {
      componentName: 'pageLayout',
    });
  }, [analytics]);
  return (
    <div className="pageLayout-errorBoundary">
      <div>Whoops! Something went wrong.</div>
      <div className="pageLayout-errorBoundary-continue" onClick={onClickContinue}>
        Click here to continue working
      </div>
    </div>
  );
}
export default PageLayout;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/page_layout.jsx